// extracted by mini-css-extract-plugin
module.exports = {"errorCode":"style_errorCode__YFnTL","errorDesc":"style_errorDesc__Eqfau","errorNav":"style_errorNav__pUdO6","btnContainer":"style_btnContainer__aHwCm","btn":"style_btn__AHT_u"};